const healthItems = [
  {
    title: 'Health Data Analytics Guidance',
    desc: 'Strategic consulting for implementing health analytics platforms, data visualization tools, and wellness tracking system integration for organizational health programs',
  },
  {
    title: 'Digital Wellness Program Advisory',
    desc: 'Guidance for developing evidence-based digital wellness programs, mobile health app integration, and employee wellness technology implementation',
  },
  {
    title: 'Health Technology Infrastructure',
    desc: 'Technical advisory for secure health data management systems, privacy compliance frameworks, and wellness platform architecture design',
  },
  {
    title: 'Regulatory Compliance Advisory',
    desc: 'Comprehensive guidance for health technology regulations, data privacy compliance, and wellness program standards ensuring adherent implementation',
  },
];

const nutritionBullets = [
  'Functional Foods Development Consultancy',
  'Nutraceuticals Optimization Advisory',
  'Nutritional Program Development',
  'Technology Transfer Services',
  'Product Development Strategy',
  'Regulatory Compliance Advisory',
];

const biosensorBullets = [
  'Biosensor Technology Development',
  'Research Collaboration Programs',
  'Molecular Detection Systems',
  'Novel Chemistries Development',
  'Next-Gen Material Design Collaboration',
];

export default function DigitalWellnessSection() {
  return (
    <section className="py-24" style={{ background: 'linear-gradient(180deg, #0e0e1a 0%, #09090f 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Health Tech
          </span>
          <h2 className="text-4xl font-light text-white mb-6 tracking-tight">
            Digital{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 600 }}>
              Wellness
            </span>{' '}
            Service
          </h2>
          <p className="text-lg text-white/45 max-w-3xl mx-auto font-light">
            AI-driven health technology and wellness solutions for personalized and data-centric health experiences
          </p>
        </div>

        {/* Wellness Banner */}
        <div className="mb-20 overflow-hidden" style={{ borderRadius: '16px', border: '1px solid rgba(201,168,76,0.2)' }}>
          <img
            alt="Éclat-Gen Digital Wellness"
            className="w-full h-64 object-cover object-center"
            src="https://public.readdy.ai/ai/img_res/a887062c49953b321e7fb15f4976e52c.jpg"
          />
          <div className="pointer-events-none" style={{ marginTop: '-4px', height: '4px', background: 'linear-gradient(90deg, transparent, rgba(201,168,76,0.4), transparent)' }} />
        </div>

        {/* Two column */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div className="p-10" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '16px' }}>
            <h3 className="text-2xl font-light text-white mb-4">
              Digital Health Technology{' '}
              <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 600 }}>
                Consultancy
              </span>
            </h3>
            <p className="text-sm text-white/45 mb-8 font-light leading-relaxed">
              Our comprehensive digital health consulting framework provides strategic guidance for implementing health technology solutions, regulatory compliance advisory, and evidence-based wellness program development.
            </p>
            <div className="space-y-4">
              {healthItems.map((item) => (
                <div
                  key={item.title}
                  className="flex items-start gap-4 p-4"
                  style={{ background: 'rgba(201,168,76,0.03)', border: '1px solid rgba(201,168,76,0.1)', borderRadius: '8px' }}
                >
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(201,168,76,0.15)', borderRadius: '50%' }}>
                    <i className="ri-check-line text-xs" style={{ color: '#c9a84c' }} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-white/80 mb-1">{item.title}</h4>
                    <p className="text-xs text-white/35 font-light leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden" style={{ borderRadius: '12px', border: '1px solid rgba(201,168,76,0.15)' }}>
            <img
              alt="Éclat-Gen Wellness Technology"
              className="w-full h-[480px] object-cover object-top"
              src="https://readdy.ai/api/search-image?query=Dark%20luxury%20wellness%20scene%20with%20diverse%20athletes%20wearing%20advanced%20fitness%20wearable%20devices%20in%20dramatic%20dark%20outdoor%20setting%20with%20warm%20golden%20accent%20lighting%2C%20professional%20runners%20using%20cutting-edge%20smartwatches%20and%20fitness%20trackers%20against%20dark%20moody%20mountain%20scenery%2C%20obsidian%20aesthetic%20with%20golden%20rim%20lighting%2C%20diverse%20professionals%20monitoring%20health%20data%20with%20state-of-the-art%20wearable%20technology%2C%20representing%20seamless%20integration%20of%20elite%20digital%20health%20technology%20in%20premium%20outdoor%20wellness%20lifestyle%2C%20cinematic%20dark%20photography&width=600&height=640&seq=eclat-wellness-wearables&orientation=portrait"
            />
          </div>
        </div>

        {/* Bottom two cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Functional Food */}
          <div
            className="p-8 transition-all duration-300"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}
          >
            <div className="w-14 h-14 flex items-center justify-center mb-5" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '10px' }}>
              <i className="ri-leaf-line text-2xl" style={{ color: '#c9a84c' }} />
            </div>
            <h3 className="text-xl font-semibold text-white/90 mb-3 tracking-wide">Functional Food &amp; Nutrition Consultancy</h3>
            <div className="mb-5 overflow-hidden" style={{ borderRadius: '8px', border: '1px solid rgba(201,168,76,0.15)' }}>
              <img
                alt="Functional Food and Nutrition Technology"
                className="w-full h-44 object-cover"
                src="https://static.readdy.ai/image/d80b109f077bb32eaa0599f7baacf71d/48c059f839e63ff335e517e034f4fb51.png"
              />
            </div>
            <p className="text-xs text-white/40 mb-5 font-light leading-relaxed">
              Strategic consultancy for functional foods development, nutraceuticals optimization, and evidence-based nutritional research programs. Technology transfer services for scaling innovative nutrition solutions and product commercialization.
            </p>
            <div className="space-y-2 mb-5">
              {nutritionBullets.map((b) => (
                <div key={b} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#c9a84c' }} />
                  <span className="text-xs text-white/40 font-light">{b}</span>
                </div>
              ))}
            </div>
            <button className="flex items-center gap-2 text-xs font-semibold tracking-wide transition-all duration-300" style={{ color: '#c9a84c' }}>
              Explore Nutrition Consultancy <i className="ri-arrow-right-line" />
            </button>
          </div>

          {/* Bio Sensor */}
          <div
            className="p-8 transition-all duration-300"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}
          >
            <div className="w-14 h-14 flex items-center justify-center mb-5" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '10px' }}>
              <i className="ri-sensor-line text-2xl" style={{ color: '#c9a84c' }} />
            </div>
            <h3 className="text-xl font-semibold text-white/90 mb-3 tracking-wide">Next-Gen Bio Sensor &amp; Research Collaboration</h3>
            <div className="mb-5 overflow-hidden" style={{ borderRadius: '8px', border: '1px solid rgba(201,168,76,0.15)' }}>
              <img
                alt="Bio Sensor Technology"
                className="w-full h-44 object-cover"
                src="https://static.readdy.ai/image/d80b109f077bb32eaa0599f7baacf71d/e26bd7e37b326b249d75192382f7c382.png"
              />
            </div>
            <p className="text-xs text-white/40 mb-5 font-light leading-relaxed">
              Advanced biosensor technology consulting and research collaboration for real-time health monitoring, molecular detection, and novel chemistry applications. Strategic partnerships for developing cutting-edge sensor technologies.
            </p>
            <div className="space-y-2 mb-5">
              {biosensorBullets.map((b) => (
                <div key={b} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#c9a84c' }} />
                  <span className="text-xs text-white/40 font-light">{b}</span>
                </div>
              ))}
            </div>
            <button className="flex items-center gap-2 text-xs font-semibold tracking-wide transition-all duration-300" style={{ color: '#c9a84c' }}>
              Discover Bio Sensor Solutions <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
